import React, { useState } from "react"

import { useQuery } from "@tanstack/react-query";

import { Empty, Divider, Modal, Spin } from "antd";

import { VisualizarDocumentoHTML } from "@/Documentos/VisualizarDocumentoHTML";
import { DocumentoService, useObterFichaDeSaudeAlunoPdf, useObterHTMLDaFichaDeSaude } from "@/Services/Domain/Documentos/DocumentoService";
import { GestaoDeGUIDs } from "@/Documentos/GestaoDeGUIDs";
import Button from "antd/lib/button";
import { HttpStatusCode } from "axios";
import * as FileSaver  from "file-saver"

export const FichaDeSaude: React.FC<
    { codigoDoAluno: number } & ({ privilegio: "administrador"; permitirCompartilhamento?: boolean } | { privilegio: "escola" })
> = (props) => {

    
    
    const htmlQuery = useObterHTMLDaFichaDeSaude(
        {
            staleTime: 60 * 1000,
            retry: false,
        },
        [
            props.codigoDoAluno,
            {
                doNotNotify: (err) => err.response?.status == HttpStatusCode.NotFound,
            },
        ]
    );

    const {
        mutate,
        isPending : isPendingPdf
    } = useObterFichaDeSaudeAlunoPdf({
        onSuccess(response, variables, context) {
            console.log(
                response, 
                response.headers, 
                response.data
            );
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'ficha_de_saude.pdf';

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="(.+)"/);

                if (fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1];
                }
            }
            FileSaver.saveAs(response.data, fileName);
        },
    });

    const guidsDisponiveis = useQuery({
        queryKey: ["DocumentoService.listarGUIDsDaFichaDeSaudeDoAluno"],
        enabled: props.privilegio == "administrador",
        queryFn: () => {
            if (props.privilegio != "administrador") return Promise.reject();
            return DocumentoService.listarGUIDsDaFichaDeSaudeDoAluno(props.codigoDoAluno);
        },
    });

    const html = htmlQuery.data?.data;

    return (
        <React.Fragment>
            {props.privilegio === "administrador" && props.permitirCompartilhamento && (
                <React.Fragment>
                    <GestaoDeGUIDs
                        title={<>Links de acesso</>}
                        guids={guidsDisponiveis.data?.data ?? []}
                        adicionar={() => DocumentoService.compartilharFichaDeSaudeDoAluno(props.codigoDoAluno, {})}
                        depoisDeAdicionar={() => guidsDisponiveis.refetch()}
                        depoisDeDesativar={() => guidsDisponiveis.refetch()}
                        ocultarSeVazio
                    />
                    <Divider style={{ margin: guidsDisponiveis.data?.data.length == 0 ? undefined : 0 }} />
                </React.Fragment>
            )}

            <Spin spinning={htmlQuery.isFetching}>
                {html ? <VisualizarDocumentoHTML html={html} isLoadingExport={isPendingPdf} onExport={() => mutate([props.codigoDoAluno, undefined])} /> : <Empty />}
            </Spin>
        </React.Fragment>
    );
};

export const FichaDeSaudeModal: React.FC<{
    fichaProps: { codigoDoAluno?: number | undefined } & React.ComponentProps<typeof FichaDeSaude>;
    buttonOpen?: React.ReactNode;
}> = ({ buttonOpen, ...props }) => {
    const [aberta, setAberta] = useState<boolean>(false);

    return (
        <>
            {(buttonOpen && React.cloneElement(buttonOpen as React.ReactElement<any>, { onClick: () => setAberta(true) })) || (
                <Button type="primary" size="small" onClick={() => setAberta(true)}>
                    Ficha de saúde
                </Button>
            )}

            <Modal
                destroyOnClose
                width={"80vw"}
                title="Ficha de saúde"
                maskClosable={false}
                open={aberta}
                footer={(_, { OkBtn }) => (
                    <>
                        <OkBtn />
                    </>
                )}
                onOk={() => {
                    setAberta(false);
                }}
                onCancel={() => {
                    setAberta(false);
                }}
            >
                <Divider />
                {props.fichaProps.codigoDoAluno ? <FichaDeSaude {...props.fichaProps} /> : <></>}
            </Modal>
        </>
    );
};